// recommended-accessories.js

document.addEventListener("DOMContentLoaded", function () {
  initRecommendedAccessoriesSwiper();
});

document.addEventListener("shopify:section:load", function (event) {
  if (event.target.querySelector(".top-picks_project")) {
    initRecommendedAccessoriesSwiper();
  }
});

function initRecommendedAccessoriesSwiper() {
  const accessoriesSections = document.querySelectorAll(".top-picks_project");

  if (!accessoriesSections.length) return;

  accessoriesSections.forEach((section) => {
    const swiperEl = section.querySelector(".top-picks-swiper");

    if (!swiperEl) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    new Swiper(swiperEl, {
      slidesPerView: "auto",

      // 👇 default = mobile
      spaceBetween: 12,

      navigation: {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 40,
        },
      },

      watchOverflow: true,
      observer: true,
      observeParents: true,
    });
  });
}
